/**
 * Created by mgoria on 03/03/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FailedToDeleteSqsMessagesException = undefined;

var _LogDriverException2 = require('./LogDriverException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when failed to delete sqs messages
 */
let FailedToDeleteSqsMessagesException = exports.FailedToDeleteSqsMessagesException = function (_LogDriverException) {
  _inherits(FailedToDeleteSqsMessagesException, _LogDriverException);

  /**
   * @param {String} sqsQueueUrl
   * @param {Object} error
   */
  function FailedToDeleteSqsMessagesException(sqsQueueUrl, error) {
    _classCallCheck(this, FailedToDeleteSqsMessagesException);

    return _possibleConstructorReturn(this, (FailedToDeleteSqsMessagesException.__proto__ || Object.getPrototypeOf(FailedToDeleteSqsMessagesException)).call(this, `Failed to delete batch messages from "${sqsQueueUrl}" SQS queue. ${error}`));
  }

  return FailedToDeleteSqsMessagesException;
}(_LogDriverException2.LogDriverException);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/Exception/FailedToDeleteSqsMessagesException.js
// module id = 398
// module chunks = 0